<div
  class="recommendation-panel tw-flex tw-flex-col tw-gap-1 tw-rounded-lg tw-shadow-lg"
  [ngClass]="{ 'tw-bg-success tw-text-white': success, 'tw-bg-zinc-200': !success }"
  [class.tw-bg-success]="success"
  [class.tw-p-2.5]="withPadding"
>
  <ng-content></ng-content>
</div>
